import {Injectable} from "@angular/core";
import {LoggerService} from "../common/logger.service";
import {UsanaObject} from "../usana-object";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class HeaderService extends UsanaObject {

    showHeaderSubject: BehaviorSubject<boolean> = new BehaviorSubject(true);

    constructor(
        loggerService: LoggerService
    ) {
        super(loggerService);
    }

    //The content of this file has been transferred to the new CategoryService.  I am still leaving this as an empty service
    //because Nic will be doing a bunch of things in her in the near future. -Dan
}
